import type { WorkspaceRole } from './useWorkspaces';

export type PermissionLoadStatus = 'idle' | 'loading' | 'ready' | 'error';

export interface PermissionResolution {
    workspaceId: string | null;
    status: PermissionLoadStatus;
}

export const resolvePermissionLoadStatus = ({
    role,
    workspaceId,
    resolution,
}: {
    role: WorkspaceRole | null;
    workspaceId?: string | null;
    resolution: PermissionResolution;
}): PermissionLoadStatus => {
    if (!role || !workspaceId) {
        return 'idle';
    }

    return resolution.workspaceId === workspaceId
        ? resolution.status
        : 'loading';
};
